// src/extenders/predictive-search-navigation.js
var PredictiveNavigation = class extends HTMLElement {
  constructor() {
    super();
    let searchFilters = this.querySelectorAll("#search-filter");
    searchFilters.forEach((filter) => {
      filter.addEventListener("click", () => {
        filterToggle(filter);
      });
    });
    document.addEventListener("search:input", () => {
      searchFilters = this.querySelectorAll("#search-filter");
      filterToggle(searchFilters[0]);
      searchFilters.forEach((filter) => {
        filter.addEventListener("click", () => {
          filterToggle(filter);
        });
      });
    });
    const filterToggle = (filter) => {
      if (!filter)
        return;
      const filterValue = filter.getAttribute("data-filter");
      filter.ariaSelected = true;
      searchFilters.forEach((filterBtn) => {
        if (filterBtn.getAttribute("data-filter") != filterValue) {
          filterBtn.ariaSelected = false;
          const grid = this.querySelector("#search-grid");
          Array.from(grid.children).forEach((item) => {
            if (item.getAttribute("data-filter") == filterValue || item.getAttribute("data-filter") == "all") {
              item.style.display = "block";
            } else {
              item.style.display = "none";
            }
            if (filterValue == "article") {
              grid.classList.remove("md:grid-cols-4");
              grid.classList.add("md:grid-cols-3", "md:max-w-[1060px]");
            } else {
              grid.classList.add("md:grid-cols-4");
              grid.classList.remove("md:grid-cols-3", "md:max-w-[1060px]");
            }
          });
        }
      });
    };
  }
};
if (customElements.get("predictive-search-navigation") === void 0) {
  customElements.define("predictive-search-navigation", PredictiveNavigation);
}
